import React from "react";
import { useApp } from "context";
import { Custom, Progress } from "components";
import { Constants, Enums, Helpers } from "utils";
import { Box } from "@mui/material";
import Scanner from "react-webcam-qr-scanner";

type Props = {
  onClick: (step: number) => void;
};

export const Scan = (props: Props) => {
  const { setFeedback, service, t, theme } = useApp();

  const [processing, setProcessing] = React.useState<boolean>(false);

  const handleHome = () =>
    props.onClick && props.onClick(Enums.EnumCheckInStep.Home);

  const handleQRCodeSubmit = async (value: string) => {
    try {
      const { eventId, appointmentId } = JSON.parse(value);
      const response = await service.google.find(
        Constants.CALENDAR_ID,
        String(eventId)
      );
      if (response) {
        setFeedback({
          message: t.message.qiosk.check_in_with_account,
          severity: Enums.EnumFeedback.Success,
        });
        const appointment = await service.appointment.find(
          Number(appointmentId)
        );
        await service.appointment.updateCheckIn(
          Number(appointmentId),
          true,
          appointment.patientId,
          true
        );
        props.onClick && props.onClick(Enums.EnumCheckInStep.Home);
      } else {
        setFeedback({
          message: t.message.qiosk.not_found,
          severity: Enums.EnumFeedback.Info,
        });
      }
    } catch (err) {
      setFeedback({
        message: t.message.feedback.request_error,
        severity: Enums.EnumFeedback.Error,
      });
    }
    setProcessing(false);
  };

  const handleDecode = (result: any) => {
    if (Helpers.hasValue(result.data)) {
      setFeedback(null);
      setProcessing(true);
      handleQRCodeSubmit(result.data);
    }
  };

  return (
    <Box
      sx={{
        width: "80%",
        display: "flex",
        alignItems: "center",
        flexDirection: "column",
      }}
    >
      <Custom.Button
        variant="outlined"
        sx={{
          fontSize: theme.font.sm,
          marginBottom: theme.margin.xl,
        }}
        onClick={handleHome}
      >
        {t.action.return_check_in}
      </Custom.Button>
      {!processing ? (
        <Scanner
          onDecode={handleDecode}
          style={{
            width: "60%",
            borderRadius: theme.border.radius * theme.border.factor,
          }}
          constraints={{
            audio: false,
            video: {
              facingMode: "environment",
            },
          }}
          captureSize={{ width: 640, height: 360 }}
        />
      ) : (
        <Box sx={{ width: 300, height: (9 / 16) * 300 }}>
          <Progress.PageProcess />
        </Box>
      )}
    </Box>
  );
};
